import React, { useState } from "react";
import {
  CHAN_SHORT,
  cleanReviewText,
  fmtDay,
  fmtInt,
  isPaid,
  str,
  toneOf,
  truthy,
  type PostRow,
  type Tone,
} from "../sandbox/resumenData";
import { MobileScreen } from "./MobileChrome";

const PAGE = 15;
const TONE_LABEL: Record<Tone, string> = { pos: "Positiva", neg: "Negativa", neu: "Neutra", none: "Sin clasificar" };
const TONE_CLASS: Record<Tone, string> = { pos: "good", neg: "bad", neu: "stable", none: "stable" };

interface Props {
  post: PostRow;
  theme: "light" | "dark";
  onBack: () => void;
  /** Abre la Bandeja en ese comentario. */
  onOpenComment?: (feedbackId: string) => void;
}

/** Comentarios de una publicación o anuncio en pantalla completa, de a 15. */
export function PublicacionesMobile({ post, theme, onBack, onOpenComment }: Props) {
  const [shown, setShown] = useState(PAGE);
  return (
    <MobileScreen title={post.name} theme={theme} onBack={onBack}>
      <div className="rz" data-testid="post-pantalla">
        <p className="rz-foot">
          {CHAN_SHORT[post.chan]} · {post.paid ? "Anuncio" : "Orgánico"} · {fmtInt(post.total)}{" "}
          {post.total === 1 ? "comentario" : "comentarios"} · {fmtInt(post.pending)} sin responder
        </p>
        <ul className="rz-mentions">
          {post.comments.slice(0, shown).map((c, i) => {
            const tone = toneOf(c);
            const answered = truthy(c.has_reply);
            const id = str(c.feedback_id);
            return (
              <li
                key={id || `${str(c.author_name)}|${str(c.date)}|${i}`}
                className={`rz-men sbx-post-card ${tone}`}
                data-testid="post-comentario"
                data-origen={isPaid(c) ? "paid" : "organic"}
              >
                <div className="top">
                  <span>
                    <b>{str(c.author_name).trim() || "Cliente"}</b>
                  </span>
                  <span>{fmtDay(str(c.date))}</span>
                </div>
                <p className="clamp3">{cleanReviewText(c.message) || "Sin texto"}</p>
                <div className="tags">
                  <span className={`sbx-loc-tag ${TONE_CLASS[tone]}`}>{TONE_LABEL[tone]}</span>
                  <span className="sbx-loc-tag stable">{answered ? "Respondida" : "Sin responder"}</span>
                </div>
                {!answered && id && onOpenComment && (
                  <button type="button" onClick={() => onOpenComment(id)}>
                    Abrir en la Bandeja
                  </button>
                )}
              </li>
            );
          })}
        </ul>
        {post.comments.length > shown && (
          <button type="button" className="rz-more" data-testid="post-ver-mas" onClick={() => setShown((n) => n + PAGE)}>
            Ver {Math.min(PAGE, post.comments.length - shown)} más
          </button>
        )}
      </div>
    </MobileScreen>
  );
}
